import { useState } from "react";
import { Radio, Typography } from "antd";
import {
  ChartsWrapper,
  DashboardWrapper,
  StyledDonutChart,
  StyledRadioGroup,
  StyledRating,
  StyledSelect,
  StyledStatusRow,
  StyledTadleWrapper,
  TitleWrapper,
} from "./styled";
import { StatisticCard } from "../StatisticCard/StatisticCard";
import { AreaChart } from "../AreaChart/AreaChart";
import { ContractorsRatingTable } from "../ContractorsRatingTable/ContractorsRatingTable";
import { ArrowLeft } from "../icons/ArrowLeft";
import { Fast } from "../icons/Fast";
import { Middle } from "../icons/Middle";
import { Slow } from "../icons/Slow";
import { ArrowDown } from "../icons/ArrowDown";

export const DashboardTab = () => {
  const [calculationInterval, setCalculationInterval] = useState("half a year");
  const currentPercent1 = 63;
  const data1 = {
    datasets: [
      {
        data: [currentPercent1, 100 - currentPercent1],
        cutout: "75%",
        backgroundColor: ["#007BFB", "#E5F2FF"],
        hoverBackgroundColor: ["#007BFB", "#E5F2FF"],
        borderWidth: 0,
      },
      {
        data: [100],
        cutout: "40%",
        radius: "140%",
        backgroundColor: ["#E5F2FF"],
        hoverBackgroundColor: ["#E5F2FF"],
        borderWidth: 0,
      },
    ],
  };

  const currentPercent2 = 25;
  const data2 = {
    datasets: [
      {
        data: [currentPercent2, 100 - currentPercent2],
        cutout: "75%",
        backgroundColor: ["#007BFB", "#E5F2FF"],
        hoverBackgroundColor: ["#007BFB", "#E5F2FF"],
        borderWidth: 0,
      },
      {
        data: [100],
        cutout: "40%",
        radius: "140%",
        backgroundColor: ["#E5F2FF"],
        hoverBackgroundColor: ["#E5F2FF"],
        borderWidth: 0,
      },
    ],
  };

  const data = [
    {
      key: "1",
      number: (
        <div style={{ display: "flex", alignItems: "center" }}>
          1
          <ArrowLeft
            style={{
              marginLeft: 12,
              width: 14,
              stroke: "#51AD77",
              transform: "rotate(90deg)",
            }}
            className="arrow"
          />
        </div>
      ),
      contrantor: "ООО Спецстрой",
      time: 2,
      unaccepted: 0,
      status: <Fast />,
    },
    {
      key: "2",
      number: (
        <div style={{ display: "flex", alignItems: "center" }}>
          2
          <ArrowLeft
            style={{
              marginLeft: 12,
              width: 14,
              stroke: "#F04B69",
              transform: "rotate(270deg)",
            }}
            className="arrow"
          />
        </div>
      ),
      contrantor: "ООО Западстройинвест",
      time: 7,
      unaccepted: 0,
      status: <Middle />,
    },
    {
      key: "3",
      number: "3",
      contrantor: "ИП Фирсов Евгений  Никитич",
      time: 14,
      unaccepted: 1,
      status: <Middle />,
    },
  ];

  const options = {
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
      },
    },
  };

  const selectOptions = [
    { label: "Алхимово", value: "Алхимово" },
    { label: "Заречье", value: "Заречье" },
  ];

   const ticksOfMonth = ["1 неделя", "2 неделя", "3 неделя", "4 неделя"];

  const ticksOfQuarter = ["Апрель", "Май", "Июнь"];

  const ticksOfHalfYear = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
  ];

  const ticksOfYear = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ];

  const dataOfMonth = [
    {
      name: "",
      time: 12,
    },
    {
      name: "1 неделя",
      time: 14,
    },
    {
      name: "",
      time: 13,
    },
    {
      name: "2 неделя",
      time: 17,
    },
    {
      name: "",
      time: 23,
    },
    {
      name: "3 неделя",
      time: 23,
    },
    {
      name: "",
      time: 12,
    },
    {
      name: "4 неделя",
      time: 19,
    },
    {
      name: "",
      time: 22,
    },
  ];

  const dataOfQuarter = [
    {
      name: "",
      time: 16,
    },
    {
      name: "Апрель",
      time: 20,
    },
    {
      name: "",
      time: 15,
    },
    {
      name: "Май",
      time: 12,
    },
    {
      name: "",
      time: 14,
    },
    {
      name: "Июнь",
      time: 13,
    },
  ];

  const dataHalfOfYear = [
    {
      name: "",
      time: 24,
    },
    {
      name: "Январь",
      time: 24,
    },
    {
      name: "",
      time: 17,
    },
    {
      name: "Февраль",
      time: 17,
    },
    {
      name: "",
      time: 24,
    },
    {
      name: "Март",
      time: 40,
    },
    {
      name: "",
      time: 24,
    },
    {
      name: "Апрель",
      time: 24,
    },
    {
      name: "",
      time: 17,
    },
    {
      name: "Май",
      time: 17,
    },
    {
      name: "",
      time: 23,
    },
    {
      name: "Июнь",
      time: 29,
    },
    {
      name: "",
      time: 21,
    },
  ];

  const dataOfYear = [
    {
      name: "Январь",
      time: 22,
    },
    {
      name: "Февраль",
      time: 24,
    },
    {
      name: "Март",
      time: 20,
    },
    {
      name: "Апрель",
      time: 17,
    },
    {
      name: "Май",
      time: 24,
    },
    {
      name: "Июнь",
      time: 40,
    },
    {
      name: "Июль",
      time: 42,
    },
    {
      name: "Август",
      time: 19,
    },
    {
      name: "Сентябрь",
      time: 24,
    },
    {
      name: "Октябрь",
      time: 17,
    },
    {
      name: "Ноябрь",
      time: 33,
    },
    {
      name: "Декабрь",
      time: 20,
    },
  ];

  const getData = () => {
    switch (calculationInterval) {
      case "half a year":
        return dataHalfOfYear;
      case "year":
        return dataOfYear;
      case "quarter":
        return dataOfQuarter;
      case "month":
        return dataOfMonth;
    }
  };

  const getTicks = () => {
    switch (calculationInterval) {
      case "half a year":
        return ticksOfHalfYear;
      case "year":
        return ticksOfYear;
      case "quarter":
        return ticksOfQuarter;
      case "month":
        return ticksOfMonth;
    }
  };

  return (
    <DashboardWrapper>
      <TitleWrapper>
        <Typography.Title style={{ color: "#2B303B", margin: 0 }} level={3}>
          Дашборд
        </Typography.Title>

        <div
          style={{
            display: "flex",
            width: "48%",
            justifyContent: "space-between",
          }}
        >
          <StyledSelect
            style={{ color: "#4a5368" }}
            allowClear={false}
            suffixIcon={<ArrowDown className="arrow-icon ant-select-suffix" />}
            defaultValue={selectOptions[0]}
            placeholder="Проекты"
            onChange={() => {}}
            options={selectOptions}
          />
          <StyledRadioGroup
            defaultValue={calculationInterval}
            buttonStyle="outline"
            onChange={(event) => {
              setCalculationInterval(event.target.value);
            }}
          >
            <Radio.Button value="month">Месяц</Radio.Button>
            <Radio.Button value="quarter">Квартал</Radio.Button>
            <Radio.Button value="half a year">Полгода</Radio.Button>
            <Radio.Button value="year">Год</Radio.Button>
          </StyledRadioGroup>
        </div>
      </TitleWrapper>
      <ChartsWrapper>
        <StyledDonutChart
          title="Принято РД подрядчиками"
          value={currentPercent1.toString()}
          data={data1}
          options={options}
          percent="9"
          transform="rotate(90deg)"
          color="#51AD77"
        />

        <StatisticCard
          percent="20"
          symbol="-"
          title="Больше всего изменений в разделе"
          value="ОВиВК"
          color="#51AD77"
          footer="12 изменений"
        />

        <StatisticCard
          percent="10"
          symbol="+"
          title="Количество изменений версии РД"
          value="СГП"
          color="#F04B69"
          footer="5 изменений"
        />

        <AreaChart
          percent="12"
          symbol="+"
          title="Средняя скорость принятия РД на стройке"
          value="23 ч"
          color="#F04B69"
          data={getData()}
          ticks={getTicks()}
        />

        <StyledDonutChart
          title="Отработано заявок на ИЗМ"
          value={currentPercent2.toString()}
          data={data2}
          options={options}
          percent="32"
          transform="rotate(270deg)"
          color="#F04B69"
        />
      </ChartsWrapper>
      <StyledRating>
        <Typography.Title
          style={{
            color: "#2B303B",
            margin: "32px 0",
            fontWeight: 600,
            fontSize: "24px",
          }}
        >
          Рейтинг подрядчиков
        </Typography.Title>
        <StyledTadleWrapper>
          <ContractorsRatingTable data={data} pagination={false} />
          <div style={{ width: 368, marginLeft: 24 }}>
            <Typography.Title
              style={{
                color: "#4A5368",
                margin: "32px 0",
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              Статусы подрядчиков
            </Typography.Title>
            <StyledStatusRow>
              <Fast />
              <Typography.Title
                style={{
                  color: "#4A5368",
                  margin: "0 0 0 12px",
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                Быстрый
                <span
                  style={{
                    color: "#8E9CBD",
                  }}
                >
                  – время принятия РД до 1 дня
                </span>
              </Typography.Title>
            </StyledStatusRow>
            <StyledStatusRow>
              <Middle />
              <Typography.Title
                style={{
                  color: "#4A5368",
                  margin: "0 0 0 12px",
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                Средний
                <span
                  style={{
                    color: "#8E9CBD",
                  }}
                >
                  – время принятия РД до 3 дней
                </span>
              </Typography.Title>
            </StyledStatusRow>
            <StyledStatusRow>
              <Slow />
              <Typography.Title
                style={{
                  color: "#4A5368",
                  margin: "0 0 0 12px",
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                Медленный
                <span
                  style={{
                    color: "#8E9CBD",
                  }}
                >
                  – время принятия РД более 3 дней
                </span>
              </Typography.Title>
            </StyledStatusRow>
          </div>
        </StyledTadleWrapper>
      </StyledRating>
    </DashboardWrapper>
  );
};
